import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { ForecastFeesChart } from '../charts/ForecastFeesChart';
import { ForecastGrossSalesChart } from '../charts/ForecastGrossSalesChart';




export const FeesForecastDashboard = () => {
  const { navState } = useNavState();


  const rsrc = useRsrc();
   // Filters
  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');
  

  useEffect(() => {
    rsrc.data('sc', 'FEES_DASHBOARD_FILTER_PLUGIN', {}).then(res => {
      setFieldDefs([
        { field: 'startPeriodId', displayName: 'Start Period', type: 'DROPDOWN', values: res.periods },
        { field: 'endPeriodId', displayName: 'End Period', type: 'DROPDOWN', values: res.periods },
        { field: 'brandIds', displayName: 'Brands', type: 'TREE', treeData: res.brandTreeData },
      ])

      if (!navState.formValues) {
        setFormValues({
            startPeriodId: res.periods[0].value,
            endPeriodId: res.periods[3].value,
            brandIds: res.brandIds,
        });
      }
    });

  }, []);

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      <Title icon={fas.faChartLine} title="DSA Forecasting" />
      

      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer}/>
     

      {/* Graphs */}
      <SpacerLayout>
        <Spacer vertical>
            <DashboardCard title="Quarter Over Quarter Gross Sales (by brand)" data-test-id={'bsales-chart'}>
                <ForecastGrossSalesChart formValues={formValues} />
            </DashboardCard>
            <DashboardCard title="Quarter Over Quarter Total Fees (by brand)" data-test-id={'bsales-chart'}>
                <ForecastFeesChart formValues={formValues} feeField={'total_fees'} />
            </DashboardCard>
            <Spacer>
              <DashboardCard title="Quarter Over Quarter Total FFS Fees (by brand)" data-test-id={'bsales-chart'}>
                <ForecastFeesChart formValues={formValues} feeField={'total_fees'}  ffs={true}/>
              </DashboardCard>
              <DashboardCard title="Quarter Over Quarter Total RDC FEES (by brand)" data-test-id={'bsales-chart'}>
                <ForecastFeesChart formValues={formValues} feeField={'total_fees'}  ffs={false}/>
              </DashboardCard> 
            </Spacer>
            
        </Spacer>
      </SpacerLayout>
    
      
    </ContentBox>

    );
};

// TODO: Standardize Dashboards
const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
}));